import {createRouter,createWebHistory} from 'vue-router'
import Main from "@/pages/Main"

const routes = [
    {
        path: '/',
        component: Main,
    },
    {
        path: '/:lang/',
        component: Main,
    },
    {
        path: '/:cat*',
        component: Main,
        // parse key-value pairs into an object
        props: route => {
            const params = route.params.cat
            const props = {}
            for (let i = 0; i < params.length; i += 2) {
                const value = i + 1 < params.length ? params[i + 1] : null
                props[params[i]] = value
            }
            return props
        }
    },
    {
        path: '/:lang/:cat*',
        component: Main,
        // parse key-value pairs into an object
        props: route => {
            const params = route.params.cat
            const props = {}
            for (let i = 0; i < params.length; i += 2) {
                const value = i + 1 < params.length ? params[i + 1] : null
                props[params[i]] = value
            }
            return props
        }
    },
]
const language = 'en';
const router = createRouter({
    mode: 'history',
    routes,
    // base: process.env.BASE_URL + (language === 'en' ? '/en' : ''),
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior() {
        return { top: 100 };
    },
})

export default router